import { Grid, TextField } from '@mui/material';
import { RHFAutocomplete, RHFSelect, RHFTextField } from 'src/components/minimals/form';
import { tagLabelOptions } from 'src/config/tagLabels';
import { LabelingTypeEnum } from 'src/types';
import { useFormContext } from 'react-hook-form';
import { ALLOWED_INPUTS } from '../types';
import { useEffect } from 'react';

type Props = {
  isMobile: boolean;
  handleDropdownChange: any;
  hasReadAccess: boolean;
};

export const LabelOptionsForm = ({ isMobile, handleDropdownChange, hasReadAccess }: Props) => {
  const displayAsFormName = 'labellingType';
  const undefinedLabelFormName = 'fallbackValue';

  const { watch, setValue } = useFormContext();
  const allowedInputs = watch('allowedInputs');
  const isRange = allowedInputs === ALLOWED_INPUTS.RANGE;

  const displayAsOptions = isRange ? [tagLabelOptions[0]] : tagLabelOptions;

  const isDisplayAsDisabled = hasReadAccess || isRange;

  useEffect(() => {
    if (isRange) {
      setValue(displayAsFormName, LabelingTypeEnum.VALUE, {
        shouldDirty: true,
        shouldValidate: true,
      });
    }
  }, [isRange, setValue, displayAsFormName]);

  return (
    <>
      <Grid item xs={isMobile ? 12 : 4}>
        {!isMobile ? (
          <RHFAutocomplete
            name={displayAsFormName}
            options={displayAsOptions.map((o) => o.value)}
            getOptionLabel={(value) => displayAsOptions.find((o) => o.value === value)?.label ?? ''}
            disableClearable
            isOptionEqualToValue={(option, value) => (!option ? true : option === value)}
            disabled={isDisplayAsDisabled}
            onChange={(_, newValue) => handleDropdownChange(newValue, displayAsFormName)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Display as"
                inputProps={{
                  ...params.inputProps,
                  'data-sm': 'data-type-input',
                }}
              />
            )}
          />
        ) : (
          <RHFSelect
            name={displayAsFormName}
            options={displayAsOptions}
            disabled={isDisplayAsDisabled}
            onChange={(event) =>
              handleDropdownChange(event.target.value as LabelingTypeEnum, displayAsFormName)
            }
            label="Display"
            testId="data-as-input"
          />
        )}
      </Grid>
      {!isRange && (
        <Grid item xs={isMobile ? 12 : 4}>
          <RHFTextField
            disabled={hasReadAccess}
            name={undefinedLabelFormName}
            testId="undefined-label-field"
            label="Undefined Label"
            type="text"
          />
        </Grid>
      )}
    </>
  );
};
